module.exports = __webpack_public_path__ + "static/media/elixir-brochur.b98122ce.pdf";